import React from "react"
import '../index.scss';
import Header from "../components/header";
import Footer from "../components/footer";
import PageMetaDefault from "../components/page-meta-default";
import { formDataFromJson } from "../constants"

const API_STATUSES = {
  INITIAL: 'INITIAL',
  SUCCESS: 'SUCCESS',
  ERROR: 'ERROR',
  PROGRESS: 'PROGRESS',
};

class ContactUs extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      name: "",
      email: "",
      desc: "",
      apiStatus: API_STATUSES.INITIAL,
      isClient: false,
    };
  }

  updateValue = (field, value) => {
    this.setState({
      [field]: value,
    });
  }

  onSubmit = (e) => {
    e.preventDefault();
    const { apiStatus } = this.state;
    if(apiStatus === API_STATUSES.PROGRESS) {
      return;
    }
    this.setState({
      apiStatus: API_STATUSES.PROGRESS,
    });
    const { name, email, desc } = this.state;
    fetch('https://formspree.io/f/xrgrlpnj', {
      method: 'post',
      headers: {
        'Accept': 'application/json'
      },
      body: formDataFromJson({
        name,
        email,
        desc
      })
    }).then((response) => {
      if (response.status < 400) {
        this.setState({
          apiStatus: API_STATUSES.SUCCESS,
        });
      } else {
        throw new Error('Something went wrong');
      }
    })
    .catch((error) => {
      this.setState({
        apiStatus: API_STATUSES.ERROR,
      });
      console.log(error)
    });
  }

  componentDidMount() {
    this.setState({
      isClient: true,
    });
  }

  render = () => {
    const { name, email, desc, apiStatus, isClient } = this.state;
    return (
      <>
        <PageMetaDefault pageTitle="Contact Us" />
        <Header />
        <div className="width-limit">
          <div id="contact-page-wrapper" className="flex">
            <div id="contact-form-div">
              <h1>Contact us</h1>
              <form onSubmit={this.onSubmit} id="contact-form">
                <div>
                  <label>
                    Name
                    <input type="text" value={name} onChange={(e) => this.updateValue('name', e.target.value)} />
                  </label>
                </div>
                <div>
                  <label>
                    Email address
                    <input type="email" value={email} onChange={(e) => this.updateValue('email', e.target.value)} />
                  </label>
                </div>
                <div>
                  <label>
                    What can we help you with today?
                    <textarea value={desc} onChange={(e) => this.updateValue('desc', e.target.value)} />
                  </label>
                </div>
                <button type="submit" className="landing-cta">Submit</button>
                {
                  apiStatus === API_STATUSES.SUCCESS && (
                    <p id="contact-form-status" className="success">Thank you for reaching out. We shall get back to you soon</p>
                  )
                }
                {
                  apiStatus === API_STATUSES.ERROR && (
                    <p id="contact-form-status" className="form-error">An error occurred. Please try again</p>
                  )
                }
                {
                  apiStatus === API_STATUSES.PROGRESS && (
                    <p id="contact-form-status">Sending request. Please wait...</p>
                  )
                }
              </form>
            </div>
            <div id="contact-address">
              <h1>Location</h1>
              {
                isClient && (
                  <iframe
                    title="EuclidXR Immersive Corporate address"
                    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3888.065711071398!2d77.64204611502082!3d12.967647018473125!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bae1546acff3abb%3A0x11183ec3ceba19f6!2sEuclidXR%20Immersive%20Pvt%20Ltd!5e0!3m2!1sen!2sin!4v1631514635517!5m2!1sen!2sin"
                    style={{border: 0, width: "100%", height: "377px" }} allowFullScreen="" loading="lazy"
                  />
                )
              }
            </div>
          </div>
        </div>
        <Footer />
      </>
    );
  }
}

export default ContactUs;
